module.exports = __webpack_public_path__ + "static/img/allCode.0153c0bf.png";